import {TableHeader} from './types';
import {parseFilterValues} from '../no-filters/utils/parse-filter-values';

/**
 * Get headers for the main Additional Providers table
 */
export function getAdditionalProvidersTableHeaders(
    specialtyFilter: string | null,
    complianceScores: Array<{specialtyCode: string, name: string}> = []
): TableHeader[] {
    const headers: TableHeader[] = [
        {key: 'npi', header: 'NPI', type: 'string', group: 'Provider Identification', defaultVisible: true},
        {key: 'full_name', header: 'Name', type: 'string', group: 'Provider Identification', defaultVisible: true},
        {key: 'first_line_practice_location_address', header: 'Address', type: 'string', group: 'Provider Location', defaultVisible: true},
        {key: 'practice_location_address_city_name', header: 'City', type: 'string', group: 'Provider Location', defaultVisible: true},
        {key: 'practice_location_address_state_name', header: 'State', type: 'string', group: 'Provider Location', defaultVisible: true},
        {key: 'practice_location_address_postal_code', header: 'Zip', type: 'string', group: 'Provider Location', defaultVisible: true},
        {key: 'aligned_group_name', header: 'Provider Group', type: 'string', group: 'Provider Identification', defaultVisible: true},
        {key: 'aligned_health_system_name', header: 'Health System Affiliation', type: 'string', group: 'Provider Identification', defaultVisible: true},
        {key: 'final_mips_score', header: 'Quality Score', type: 'number', precision: .01, defaultVisible: true},
        {key: 'marginal_impact_time', header: 'Impact Time', type: 'percentfloor', precision: .1, group: 'Impact on Adequacy', defaultVisible: true},
        {key: 'marginal_impact_distance', header: 'Impact Distance', type: 'percentfloor', precision: .1, group: 'Impact on Adequacy', defaultVisible: true},
        {key: 'anthem', header: 'Anthem', type: 'boolean', group: 'payor_affiliations', defaultVisible: false},
        {key: 'carefirst_bcbs', header: 'CareFirst BCBS', type: 'boolean', group: 'payor_affiliations', defaultVisible: false},
        {key: 'cigna', header: 'Cigna', type: 'boolean', group: 'payor_affiliations', defaultVisible: false},
        {key: 'excellus', header: 'Excellus', type: 'boolean', group: 'payor_affiliations', defaultVisible: false},
        {key: 'independent_health', header: 'Independent Health', type: 'boolean', group: 'payor_affiliations', defaultVisible: false},
        {key: 'united', header: 'United', type: 'boolean', group: 'payor_affiliations', defaultVisible: false},
        {key: 'accuracy_level', header: 'Accuracy Level', type: 'string', group: 'Location and Affiliation Confidence', defaultVisible: false},
        {key: 'se_location_weight', header: 'Location Weight Standard Error', type: 'number', precision: .01, group: 'Location and Affiliation Confidence', defaultVisible: false},
        {key: 'primary_ci_overlaps_secondary', header: 'Imprecise Primary Location', type: 'string', group: 'Location and Affiliation Confidence', defaultVisible: false},
        {key: 'latest_ffs_year', header: 'Latest FFS Year', type: 'string', group: 'Provider Activity', defaultVisible: false},
        {key: 'latest_ma_year', header: 'Latest MA Year', type: 'string', group: 'Provider Activity', defaultVisible: false},
        {key: 'latest_mco_year', header: 'Latest MCO Year', type: 'string', group: 'Provider Activity', defaultVisible: false},
        {key: 'latest_commercial_year', header: 'Latest Commercial Year', type: 'string', group: 'Provider Activity', defaultVisible: false},
        {key: 'ffs_flag', header: 'FFS Flag', type: 'string', group: 'Provider Activity', defaultVisible: false},
        {key: 'ma_flag', header: 'MA Flag', type: 'string', group: 'Provider Activity', defaultVisible: false},
        {key: 'mco_flag', header: 'MCO Flag', type: 'string', group: 'Provider Activity', defaultVisible: false},
        {key: 'com_flag', header: 'Commercial Flag', type: 'string', group: 'Provider Activity', defaultVisible: false},
    ];

    // Specialty-specific columns
    // Check if any selected specialty is Acute Inpatient Hospital by resolving codes to names
    const hasAcuteInpatientHospital = specialtyFilter
        ? parseFilterValues(specialtyFilter).some(code => {
            const specialty = complianceScores.find(s => s.specialtyCode === code);
            return specialty?.name === 'Acute Inpatient Hospital';
        })
        : false;

    if (hasAcuteInpatientHospital) {
        headers.push({key: 'beds', header: 'Beds', type: 'number', group: '', defaultVisible: false});
    }

    return headers;
}

